var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 27,
    viewBox: "0 0 37 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0H40L39 27H0L12.5 0Z",
    fill: "#14489F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1719 7.93874C27.3436 7.10376 26.0119 7.10376 25.1836 7.93874L17.1362 16.03C16.9406 16.2324 16.8258 16.4714 16.7932 16.7158L16.7925 16.7209L16.3513 19.8416L18.8903 19.4808V19.467L19.4598 19.3911C19.7067 19.3581 19.9352 19.2436 20.1099 19.058L20.1161 19.0515L28.1725 10.9513L28.1737 10.95C29.0014 10.1223 29.0041 8.77767 28.1719 7.93874ZM24.2523 7.01393C25.594 5.66187 27.7621 5.66202 29.1037 7.01439C30.4412 8.36273 30.4441 10.5351 29.1025 11.8774L29.1018 11.8781L21.0589 19.9647C20.8144 20.2224 20.5217 20.4175 20.2028 20.5438V20.6199L16.2526 21.1813L16.2505 21.1815C15.9208 21.2274 15.5715 21.1401 15.3151 20.8869C15.0573 20.6321 14.9657 20.281 15.0112 19.9449L15.0117 19.9409L15.4926 16.5395C15.5654 15.9986 15.8171 15.5046 16.1969 15.1132L16.2024 15.1075L24.2523 7.01393Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8774 9.27641C27.1347 9.53172 27.1363 9.94724 26.8809 10.2045L25.7172 11.377C25.4619 11.6342 25.0464 11.6358 24.7892 11.3805C24.5319 11.1252 24.5304 10.7096 24.7857 10.4524L25.9494 9.2799C26.2047 9.02265 26.6202 9.02109 26.8774 9.27641Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9038 22.4141C23.9038 22.0516 24.1976 21.7578 24.5601 21.7578H29.6613C30.0237 21.7578 30.3176 22.0516 30.3176 22.4141C30.3176 22.7765 30.0237 23.0703 29.6613 23.0703H24.5601C24.1976 23.0703 23.9038 22.7765 23.9038 22.4141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicEdit);
export default __webpack_public_path__ + "static/media/topic_edit.dea0ba0ee31c878a18aeccdf81e97a76.svg";
export { ForwardRef as ReactComponent };